import React from "react";
import Banner from "../../../../Components/Banner";
import Img from "../../../../assets/images/image";
import WhatMakesUsDifferent from "../../../../Components/WhatMakesUsDifferent";
import GetInTouch from "../../../../Components/GetInTouch";
import { data } from "../../../../Data/data";
import { Helmet } from "react-helmet";
import TwoColumn from "../../../../Components/TwoColumn";
import HeroSection from "../../../../Components/HeroSection/HeroSection";

const DesignDevelopment = () => {
   return (
      <div className="animation fadeIn">
         <Helmet>
            <title>Experience the innovative Web design development agency</title>
            <meta name="description" content="Transform your business old designs with the innovative web design development agency. Get your visually appealing UI/UX designs for your website now." />
            <link rel="canonical" href="https://www.witmates.com/services/project-development/design_development" /> 
         </Helmet>

         <HeroSection
            image={Img.designDevelopmentBanner}
            heading={
               <>
                  Dive into the <span className="witmates-theme-color">digital</span> world through an <span className="witmates-theme-color">impressive UI/UX</span> web design development agency.
               </>
            }
            description={
               <>
                  We believe in the power of intuitive web design development agency. that has a lasting impression on users’ minds. Our UI/UX and web design development services focus on creating
                  visually appealing, user-friendly interfaces that enhance the overall digital experience.
               </>
            }
            link
         />

         <section className="pt100 pb100 mobPt50 mobPb20">
            <div className="d-flex justify-content-center align-items-center">
               <TwoColumn
                  image={Img.designDevelopment}
                  heading={
                     <>
                        UI/UX Design <br /> Development
                     </>
                  }
                  pageName="UI/UX"
                  buttonName="BUILD TOGETHER"
                  redirection="/get-in-touch"
                  subPoints={["Wire Framing", "Sprint Design"]}
                  isZoom={true}
                  description={
                     <>
                        At Witmates, we are driven by the belief in the transformative power of intuitive designs. Our UI/UX design and web design development services are dedicated to creating
                        visually appealing and user-friendly interfaces that provide a delightful user experience. We understand that a captivating digital experience goes beyond mere aesthetics.
                        That's why we combine stunning visuals with seamless functionality, resulting in interfaces that captivate and keep users coming back for more.
                        <br />
                        Throughout our process, we dive deep into understanding your target audience - their preferences, behaviours, and desires - ensuring that every design element serves a purpose
                        and revolves around their needs.
                        <br />
                        By focusing on intuitive design principles and industry best practices, we ensure that your websites or applications become more than just functional tools - they become
                        unforgettable experiences.
                        <br />
                        Let's transform your digital presence into a visually stunning and user-friendly masterpiece. Connect with us, if you’re looking for a Website design development company to
                        make a lasting impact on your website and applications.
                     </>
                  }
               />
            </div>
         </section>
         <WhatMakesUsDifferent data={data.designDevelopmentData} height="415px" />
         <GetInTouch />
      </div>
   );
};

export default DesignDevelopment;
